module.exports = __webpack_public_path__ + "static/media/picard3.6c274d28.jpg";